import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { WarningIcon, FlagIcon, NotLinkedIcon } from "fe-shared/src/components/Icons";

import { GridTransactionInternal } from "types";

import styles from "./FlagsRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridTransactionInternal;
}

const FlagsRenderer = (props: Props) => {
  const { hasAutoFlag, hasManualFlag, hasNotLinkedFlag } = props.data;

  return (
    <div className={styles.flags}>
      {hasAutoFlag && <WarningIcon />}
      {hasManualFlag && <FlagIcon fillColor="#E64040" />}
      {hasNotLinkedFlag && <NotLinkedIcon />}
    </div>
  );
};

export default FlagsRenderer;
